<template>
  <div class="jgqs-content">
    <v-title :item="sjObj">{{ sjObj.name }}</v-title>
    <!-- <div class="tab-box flex">
      <div
        v-for="(item, index) in yearList"
        :key="index"
        class="tab-item"
        :class="{ active: active === index }"
        @click="changeType(index)"
      >
        <span>{{ item }}</span>
      </div>
    </div> -->
    <div class="chart" ref="chart" />
  </div>
</template>

<script>
// import { timerMixin } from "@/util/mixin/timerMixin";
import { get } from "@/api/index";
// import { getDataPriceDetailByYear } from "@/api/schj";
import { loadChart } from "../chart/lzczData";
export default {
  //   mixins: [timerMixin],
  data() {
    const year = new Date().getFullYear();
    return {
      sjObj: {
        name: "收购价格趋势(" + year + ")",
        hasBtn: true,
      },
      typeList: [],
      active: 0,
      chart: null,
      // yearList: [year + "年", year - 1 + "年"]
    };
  },
  mounted() {
    //价格变化趋势-折线图
    this.chart = this.$echarts.init(this.$refs.chart);
    this.loadData();
    // this.startTimer();
    window.addEventListener("resize", () => {
      this.chart.resize();
    });
  },
  methods: {
    // runs() {
    //   let len = this.yearList.length;
    //   let active = Number(this.active);
    //   if (active < len - 1) {
    //     active++;
    //   } else {
    //     active = 0;
    //   }

    //   this.changeType(active);
    // },
    // changeType(index, clearT = true) {
    //   this.active = index;
    //   this.loadData();
    //   if (clearT) {
    //     this.startTimer();
    //   }
    // },
    loadData() {
      get("../zlzb_service/open/api/data_price_chart", {
        day: this.active,
      }).then((res) => {
        this.typeList = res.names;
        const datas = res.datas;
        let dateArr = [];
        let dataArr = [];
        res.names.forEach((e, i) => {
          const data = datas[e];
          if (i === 0) {
            dateArr = data.map((d) => {
              return d.date;
            });
          }
          const vals = data.map((d) => {
            return Number(d.price);
          });
          dataArr.push(vals);
        });
        this.getQsData(dateArr, dataArr);
      });
      /* getDataPriceDetailByYear({
        year: this.yearList[this.active].split("年")[0]
      }).then(res => {
        let data = res.data;
        let sgArr = [];
        let cdArr = [];
        let dateArr = [];
        data.map(item => {
          sgArr.push(Number(item.sg_price_));
          cdArr.push(Number(item.cd_price_));
          dateArr.push(this.timestampToTime(item.date_));
        });
        this.getQsData(dateArr, sgArr, cdArr);
      }); */
    },
    getQsData(yearlist, bfData) {
      const resultArr = this.typeList;
      const unit = "元/公斤";
      loadChart(this.chart, resultArr, yearlist, bfData, unit);
    },
  },
};
</script>

<style lang="stylus" scoped>
.jgqs-content
    height 100%
    position relative
    .chart
        height calc(100% - 38px)
    .tab-box
        position absolute
        top 40px
        right 2%
        z-index 999
        .tab-item
            color #fff
            font-size 10px
            padding-left 13px
            margin-right 20px
            position relative
            cursor pointer
            &:before
                content ' '
                width 12px
                height 12px
                border-radius 50%
                background #fff
                position absolute
                left 0
                top 50%
                transform translateY(-50%)
        .active
            color #0e9cff
            &:before
                background #0e9cff
</style>
